<template>
  <main class="common-container">
    <!-- <section class="page-title flash-title">
      <h2>{{ $t("chart1.tradingView") }}</h2>
    </section> -->

    <section class="explanation-container center">
      <p class="center-sentence">
        {{ $t("crossExp.descText1") }}<br />
        {{ $t("doubleExp.descText2") }}<br />
        {{ $t("doubleExp.descText3") }}
      </p>
    </section>
  </main>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
